(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-bundle-selector"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initBundle(root) {
        if (root.dataset.wwInit) return;
        root.dataset.wwInit = '1';
        var radios = root.querySelectorAll('[data-ww-radio]');
        var buyBtn = root.querySelector('[data-ww-buy]');
        var singleId = root.getAttribute('data-ww-single');
        var threeId = root.getAttribute('data-ww-three');
        var upsell = root.querySelector('[data-ww-upsell]');

        function selectedId() {
          var checked = root.querySelector('[data-ww-radio]:checked');
          return checked ? checked.value : threeId;
        }

        radios.forEach(function (r) {
          r.addEventListener('change', function () {
            root.querySelectorAll('.ww-opt').forEach(function (o) { o.classList.remove('is-active'); });
            var label = r.closest('.ww-opt');
            if (label) label.classList.add('is-active');
          });
        });

        // thumbnail gallery
        root.querySelectorAll('[data-ww-thumb]').forEach(function (t) {
          t.addEventListener('click', function () {
            var target = document.getElementById(t.getAttribute('data-target'));
            if (target) target.src = t.getAttribute('data-src');
            root.querySelectorAll('[data-ww-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
            t.classList.add('is-active');
          });
        });

        // Buy now -> clear cart, add selected variant, go straight to checkout
        function proceed(variantId) {
          if (buyBtn) { buyBtn.setAttribute('aria-busy', 'true'); var lbl = buyBtn.querySelector('.ww-bundle__add-label'); if (lbl) lbl.textContent = 'Taking you to checkout…'; }
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
              });
            })
            .then(function () { window.location.href = '/checkout'; })
            .catch(function () { window.location.href = '/cart/' + variantId + ':1'; });
        }

        function buy() {
          var sel = selectedId();
          var seen = false;
          try { seen = sessionStorage.getItem('ww_upsell_seen') === '1'; } catch (e) {}
          if (sel === singleId && !seen && upsell && typeof upsell.showModal === 'function') {
            upsell.showModal();
          } else {
            proceed(sel);
          }
        }

        if (buyBtn) buyBtn.addEventListener('click', buy);

        if (upsell) {
          function markSeen() { try { sessionStorage.setItem('ww_upsell_seen', '1'); } catch (e) {} }
          function closeUpsell() { try { upsell.close(); } catch (e) {} }
          var yes = upsell.querySelector('[data-ww-upsell-yes]');
          var no = upsell.querySelector('[data-ww-upsell-no]');
          var x = upsell.querySelector('[data-ww-upsell-close]');
          if (yes) yes.addEventListener('click', function () {
            var threeRadio = root.querySelector('[data-ww-radio][value="' + threeId + '"]');
            if (threeRadio) { threeRadio.checked = true; threeRadio.dispatchEvent(new Event('change', { bubbles: true })); }
            markSeen(); closeUpsell(); proceed(threeId);
          });
          if (no) no.addEventListener('click', function () { markSeen(); closeUpsell(); proceed(singleId); });
          if (x) x.addEventListener('click', function () { markSeen(); closeUpsell(); });
        }
      }
      function boot() { document.querySelectorAll('.ww-bundle[data-ww-single]').forEach(initBundle); }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
